import { QueryKey } from '@/layouts/shared';
import { AxiosErrorResponse, AxiosResponse, instanceNews } from '@/libs/axios';
import { QueryObserverOptions, useQuery } from 'react-query';
import { ParamsPayload, PostResponse } from './const';

export const fetchNews = (params: string | ParamsPayload) => {
  return instanceNews.get('/wp-json/wp/v2/posts', { params });
};
export const fetchBlog = (id: string) => {
  return instanceNews.get(`/wp-json/wp/v2/categories/${id}`);
};
export const fetchBlogBuySlug = (slug: string) => {
  return instanceNews.get(`/wp-json/wp/v2/categories?slug=${slug}`);
};
export const fetchBlogs = () => {
  return instanceNews.get(`/wp-json/wp/v2/categories`);
};
export const useFetchBlogQuery = (
  id: string,
  options?: QueryObserverOptions<AxiosResponse<any>, AxiosErrorResponse, any, AxiosResponse<any>, (string | any)[]>
) => {
  return useQuery(
    [QueryKey.Blog, id],
    ({ queryKey }) => {
      const [, id] = queryKey;
      return fetchBlog(id);
    },
    options
  );
};

export const fetchNewsBySlug = (id: string | number) => {
  return instanceNews.get(`/wp-json/wp/v2/posts?slug=${id}`);
};
export const useFetchArticleQuery = (
  id: string | number,
  options?: QueryObserverOptions<
    AxiosResponse<PostResponse>,
    AxiosErrorResponse,
    PostResponse,
    AxiosResponse<PostResponse>,
    (string | number | any)[]
  >
) => {
  return useQuery(
    [QueryKey.Article, id],
    ({ queryKey }) => {
      const [, id] = queryKey;
      return fetchNewsBySlug(id);
    },
    options
  );
};
